module.exports = __webpack_public_path__ + "img/19.0a54f2a9.jpg";